import { Outlet } from "react-router-dom";
import Footer from "./Footer/Footer";
import Navbar from "./Navbar/Navbar";
import MainContent from "./MainContent/MainContent";
import ThemeToggle from "../ThemeToggle/ThemeToggle";

export default function PublicLayoutPages() {
  return (
    <div className="portal-shell public-layout-shell">
      <MainContent>
        <div className="relative z-10 flex min-h-screen flex-col px-2 gap-4 pt-2 md:px-2.5">
          <Navbar />
          <div className="portal-panel-soft flex-1 flex items-center justify-center rounded-[1.75rem] p-2 md:p-3">
            <Outlet />
          </div>
          <Footer />
        </div>
      </MainContent>
      {/* <ThemeToggle /> */}
    </div>
  );
}
